import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@mui/material/Tooltip';
import './Sync-button.scss';

const CustomToolTip = withStyles({
  tooltip: {
    color: 'white',
    backgroundColor: 'black',
  },
})(Tooltip);

const SyncButton = (props) => {
  const { lastSync, onClickSync } = props;
  return (
    <div>
      <CustomToolTip title={`Last Sync: ${lastSync}`} placement='bottom-start'>
        <div className='circle-btn' onClick={(e) => onClickSync(e)}>
          <img
            className='mt-1 ms-1 refresh-icon'
            src={'./assets/icons/dashboard/sync-icon.svg'}
            alt={'completed'}
          />
        </div>
      </CustomToolTip>
    </div>
  );
};

export default SyncButton;
